/* Kroonjuweeltjes — wishlist (bewaard per browser) */
(function () {
  var KEY = 'kj_wishlist';
  var HEART = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M12 20.4s-7.6-4.6-7.6-10.2A4.3 4.3 0 0 1 12 7.5a4.3 4.3 0 0 1 7.6 2.7c0 5.6-7.6 10.2-7.6 10.2z" fill="var(--kjw-fill, none)" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function get() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function save(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    update();
    if (document.querySelector('[data-kjw-page]')) renderPage();
  }
  function toggle(handle) {
    var list = get();
    list = list.indexOf(handle) > -1 ? list.filter(function (h) { return h !== handle; }) : [handle].concat(list);
    save(list);
  }
  function handleFrom(href) {
    var m = (href || '').match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function makeButton(handle, variant) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'kjw-btn kjw-btn--' + variant;
    b.setAttribute('data-handle', handle);
    b.innerHTML = HEART + (variant === 'pdp' ? '<span class="kjw-label"></span>' : '');
    b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); toggle(handle); });
    return b;
  }
  function update() {
    var list = get();
    document.querySelectorAll('.kjw-btn').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-handle')) > -1;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
      var label = b.querySelector('.kjw-label');
      if (label) label.textContent = on ? 'Saved to your wishlist' : 'Add to wishlist';
    });
    document.querySelectorAll('.kjw-count').forEach(function (c) {
      c.textContent = list.length ? String(list.length) : '';
      c.hidden = !list.length;
    });
  }
  function addHeaderLink() {
    if (document.querySelector('.kjw-header')) return;
    var actions = document.querySelector('header-actions');
    if (!actions) return;
    var a = document.createElement('a');
    a.href = root + 'pages/wishlist';
    a.className = 'header-actions__action kjw-header';
    a.setAttribute('aria-label', 'Wishlist');
    a.innerHTML = '<span class="svg-wrapper">' + HEART + '</span><span class="kjw-count" hidden></span>';
    var cart = actions.querySelector('[aria-controls="cart-drawer"], .action__cart');
    if (cart) actions.insertBefore(a, cart); else actions.appendChild(a);
  }
  function decorate() {
    document.querySelectorAll('product-card:not([data-kjw])').forEach(function (card) {
      card.setAttribute('data-kjw', '1');
      var link = card.querySelector('a.product-card__link');
      var h = handleFrom(link && link.getAttribute('href'));
      if (!h) return;
      card.appendChild(makeButton(h, 'card'));
    });
    document.querySelectorAll('a.kj-pcard:not([data-kjw])').forEach(function (a) {
      a.setAttribute('data-kjw', '1');
      var h = handleFrom(a.getAttribute('href'));
      var fig = a.querySelector('figure');
      if (h && fig) fig.appendChild(makeButton(h, 'card'));
    });
    var main = document.getElementById('MainContent');
    if (main && (main.getAttribute('data-template') || '').indexOf('product') === 0 && !document.querySelector('.kjw-btn--pdp')) {
      var ph = handleFrom(location.pathname);
      var title = main.querySelector('h1');
      if (ph && title) title.insertAdjacentElement('afterend', makeButton(ph, 'pdp'));
    }
    addHeaderLink();
    update();
  }
  function money(cents, currency) {
    try { return (cents / 100).toLocaleString(document.documentElement.lang || 'en', { style: 'currency', currency: currency }); }
    catch (e) { return '€' + (cents / 100).toFixed(2); }
  }
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text) n.textContent = text; return n; }
  var rendering = false;
  function sharedList() {
    var p = new URLSearchParams(location.search).get('items');
    if (!p) return null;
    return p.split(',').map(function (h) { return h.trim(); }).filter(Boolean).slice(0, 60);
  }
  function shareUrl() {
    return location.origin + root + 'pages/wishlist?items=' + get().map(encodeURIComponent).join(',');
  }
  function flash(btn, text) {
    var old = btn.getAttribute('data-label') || btn.textContent;
    btn.setAttribute('data-label', old);
    btn.textContent = text;
    setTimeout(function () { btn.textContent = old; }, 2200);
  }
  function setupActions(page, shared) {
    var bar = page.querySelector('.kjw-actions');
    var sbar = page.querySelector('.kjw-shared');
    if (!bar || !sbar) return;
    if (shared) {
      bar.hidden = true; sbar.hidden = false;
      var save = sbar.querySelector('[data-kjw-save]');
      if (save && !save._kjw) {
        save._kjw = 1;
        save.addEventListener('click', function () {
          var mine = get();
          shared.forEach(function (h) { if (mine.indexOf(h) < 0) mine.push(h); });
          try { localStorage.setItem(KEY, JSON.stringify(mine)); } catch (e) {}
          location.href = root + 'pages/wishlist';
        });
      }
      return;
    }
    sbar.hidden = true;
    bar.hidden = !get().length;
    var share = bar.querySelector('[data-kjw-share]');
    var mail = bar.querySelector('[data-kjw-mail]');
    if (share && !share._kjw) {
      share._kjw = 1;
      share.addEventListener('click', function () {
        var url = shareUrl();
        if (navigator.share) {
          navigator.share({ title: 'My Kroonjuweeltjes wishlist', url: url }).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () { flash(share, 'Link copied'); });
        } else { window.prompt('Copy your wishlist link:', url); }
      });
    }
    if (mail && !mail._kjw) {
      mail._kjw = 1;
      mail.addEventListener('click', function () {
        location.href = 'mailto:?subject=' + encodeURIComponent('My Kroonjuweeltjes wishlist') +
          '&body=' + encodeURIComponent('My favourite vintage pieces at Kroonjuweeltjes:\n\n' + shareUrl());
      });
    }
  }
  function renderPage() {
    var page = document.querySelector('[data-kjw-page]');
    if (!page || rendering) return;
    rendering = true;
    var grid = page.querySelector('.kjw-grid');
    var empty = page.querySelector('.kjw-empty');
    var shared = sharedList();
    var list = shared || get();
    setupActions(page, shared);
    if (!list.length) { grid.innerHTML = ''; empty.hidden = false; rendering = false; return; }
    empty.hidden = true;
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    Promise.all(list.map(function (h) {
      return fetch(root + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (items) {
      grid.innerHTML = '';
      items.forEach(function (p) {
        if (!p) return;
        var a = el('a', 'kj-pcard kjw-item'); a.href = p.url; a.setAttribute('data-kjw', '1');
        var fig = el('figure');
        if (p.featured_image) {
          var img = document.createElement('img');
          var src = p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image;
          img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=600';
          img.alt = p.title; img.loading = 'lazy';
          fig.appendChild(img);
        }
        if (!p.available) fig.appendChild(el('span', 'kjw-sold', 'Sold'));
        fig.appendChild(makeButton(p.handle, 'card'));
        a.appendChild(fig);
        if (p.vendor) a.appendChild(el('span', 'vendor', p.vendor));
        a.appendChild(el('span', 'ptitle', p.title));
        if (p.available) a.appendChild(el('span', 'pprice', money(p.price, currency)));
        grid.appendChild(a);
      });
      if (!grid.children.length) empty.hidden = false;
      update();
      rendering = false;
    });
  }
  var t;
  function init() {
    decorate();
    renderPage();
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(decorate, 150); })
      .observe(document.body, { childList: true, subtree: true });
    window.addEventListener('storage', function (e) { if (e.key === KEY) { update(); renderPage(); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
